import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

const icons = {
    AccountBalanceIcon
};

const techFinDashboard = {
    id: 'group_tech_fin_dashboard',
    type: 'group',
    children: [
        {
            id: 'tech_fin_dashboard_1',
            title: 'Invoicing Dashboard',
            type: 'item',
            url: '/finance_dashboard',
            icon: icons.AccountBalanceIcon,
            breadcrumbs: false
        }
    ]
};

export default techFinDashboard;